import { createContext, useContext } from "react";
import { useTrips } from "../hooks";
const Context = createContext();

export const TripsProvider = ({ children }) => {
  return <Context.Provider value={useTrips()}>{children}</Context.Provider>;
};

export const useTripsContext = () => useContext(Context);
